import { Constants } from "../utils/constants";

export function removeExtension(name)
{
    let indexOfDot= name.lastIndexOf(".");
return name.slice(0,indexOfDot)
}

export const checkIfDomainExists = url => {
    return url?.split('/')?.includes('https:') ? url : Constants.URL.base + url
  }